export const flysync = {
  companyName: 'FlySync',
  corporateName: 'Flysync',
  title: 'Flysync Technologies',
  templateConfig: 'template1',
  email: 'support@flysync.in',
  phone: '+91 9500120014',
  address:
    '<div><strong>Ghatala Towers</strong>, <br>Avenue Rd, Ponnangipuram, Tirumurthy Nagar, Nungambakkam, Chennai, Tamil Nadu 600034</div>',
  apiUrl: 'https://b2b-common.flysync.in/backend/',
  isFullBGimage: 'Y',
  agentNavigate: '',
  isHotel: true,
  poweredBy: true,
  instagram: 'https://www.instagram.com/flysync_tours/',
  facebook: 'https://www.facebook.com/flysync.in/',
  twitter: '',
  linkedin: '',
  youtube: '',
  sentryDsn:
    'https://67269001d7387ce208d73a9eb29708e3@o4509110763126784.ingest.us.sentry.io/4509110770663424',
  registerAddress: '',
  registerCompanyName: '',
  registerEmail: '',
  registerMobile: '',
  registerNo: '',
  providerCodes: ['INV', 'TJ', 'TBO', 'AKASA', 'BTT', 'KF', 'RJ', 'KT', 'MP', 'FB', 'AIQ'],
  cancellationCharges: '{"DO":"250","IN":"500"}',
  encrypt: 'N',
  securePayment: 'true',
  encryptionSecretKey: 'd1e622507595486ee06db24b1debf11064edd2ba',
};
